// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      },
      { title: 'List Aset', path: PATH_DASHBOARD.general.asset, icon: ICONS.ecommerce },
      { title: 'List Wishlist', path: PATH_DASHBOARD.general.wishlistall, icon: ICONS.user }
    ]
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'Referensi',
        path: PATH_DASHBOARD.referensi.root,
        icon: ICONS.user,
        children: [
          { title: 'KPKNL', path: PATH_DASHBOARD.referensi.kpknl },
          { title: 'Kategori', path: PATH_DASHBOARD.referensi.kategori },
          { title: 'Promo', path: PATH_DASHBOARD.referensi.advertising },
          { title: 'Page List', path: PATH_DASHBOARD.pages.disclaimer },
          { title: 'Contact Person', path: PATH_DASHBOARD.referensi.contactperson }
        ]
      }
    ]
  }

  // APP
  // ----------------------------------------------------------------------
];

export default sidebarConfig;
